let rights = {
  dashboard: {
    web: {
      create: false,
      view: false,
      edit: false,
      delete: false
    },
    mobile: {
      create: false,
      view: false,
      edit: false,
      delete: false
    }
  },
  meetingNotes: {
    web: {
      create: false,
      view: false,
      edit: false,
      delete: false
    },
    mobile: {
      create: false,
      view: false,
      edit: false,
      delete: false
    }
  },
  communication: {
    web: {
      create: false,
      view: false,
      edit: false,
      delete: false
    },
    mobile: {
      create: false,
      view: false,
      edit: false,
      delete: false
    }
  },
  cad: {
    web: {
      create: false,
      view: false,
      edit: false,
      delete: false
    },
    mobile: {
      create: false,
      view: false,
      edit: false,
      delete: false
    }
  },
  fabric: {
    fabric: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    yarnDyed: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    embroidery: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    print: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    solidGreige: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    supplier: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    }
  },
  bNumber: {
    web: {
      create: false,
      view: false,
      edit: false,
      delete: false
    },
    mobile: {
      create: false,
      view: false,
      edit: false,
      delete: false
    }
  },
  bulkImport: {
    web: {
      create: false,
      view: false,
      edit: false,
      delete: false
    },
    mobile: {
      create: false,
      view: false,
      edit: false,
      delete: false
    }
  },
  printFabricNumber: {
    web: {
      create: false,
      view: false,
      edit: false,
      delete: false
    },
    mobile: {
      create: false,
      view: false,
      edit: false,
      delete: false
    }
  },
  trim: {
    trim: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    supplier: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    }
  },
  sourcing: {
    web: {
      create: false,
      view: false,
      edit: false,
      delete: false
    },
    mobile: {
      create: false,
      view: false,
      edit: false,
      delete: false
    }
  },
  product: {
    product: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    sample: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    pattern: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    garmentTech: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    fabric: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    trim: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    embellishment: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    cutting: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    sewing: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    dispatch: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    signOff: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    }
  },
  style: {
    web: {
      create: false,
      view: false,
      edit: false,
      delete: false
    },
    mobile: {
      create: false,
      view: false,
      edit: false,
      delete: false
    }
  },
  createIb: {
    createIb: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    orderDetails: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    garmentProcess: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    fabricDetails: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    trim: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    embroidery: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    embellishment: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    sealingDetails: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    otherDetails: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    }
  },
  smvCalcThread: {
    web: {
      create: false,
      view: false,
      edit: false,
      delete: false
    },
    mobile: {
      create: false,
      view: false,
      edit: false,
      delete: false
    }
  },
  technicalIssues: {
    web: {
      create: false,
      view: false,
      edit: false,
      delete: false
    },
    mobile: {
      create: false,
      view: false,
      edit: false,
      delete: false
    }
  },
  sampleRequest: {
    sampleRequest: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    sampleTag: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    sample: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    cad: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    fabric: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    trim: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    pattern: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    cutting: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    sewing: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    garmentTech: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    embellishment: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    embroidery: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    wash: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    dispatch: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    QC: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    marker: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    costing: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    signoff: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    }
  },
  costing: {
    web: {
      create: false,
      view: false,
      edit: false,
      delete: false
    },
    mobile: {
      create: false,
      view: false,
      edit: false,
      delete: false
    }
  },
  system: {
    web: {
      create: false,
      view: false,
      edit: false,
      delete: false
    },
    mobile: {
      create: false,
      view: false,
      edit: false,
      delete: false
    }
  },
  customer: {
    customer:{
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
    },
    web: {
      create: false,
      view: false,
      edit: false,
      delete: false
    },
    mobile: {
      create: false,
      view: false,
      edit: false,
      delete: false
    },
    withoutpoms:{
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
    },
    masterpom: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
    },
    garmentpom:{
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
    }
  },
  permissions: {
    employeeDetails: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    roleManagement: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    }
  },
  reports: {
    web: {
      create: false,
      view: false,
      edit: false,
      delete: false
    },
    mobile: {
      create: false,
      view: false,
      edit: false,
      delete: false
    },
    fabric: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    dispatch: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    outstandingCustomer: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    bNumber: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    processCompleted: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    patternMasterReport: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    processUpdates: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    fabPricePending: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    fabricLibrary: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    sampleLibrary: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    sampleProcesses: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    bulkUpdateDispatch: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    bulkUpdateProcess: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    sampleRequestDownloads: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    },
    styleDownloads: {
      web: {
        create: false,
        view: false,
        edit: false,
        delete: false
      },
      mobile: {
        create: false,
        view: false,
        edit: false,
        delete: false
      }
    }
  }
};

export default rights;


// WEBPACK FOOTER //
// ./src/services/common/rights.js